// @noflow

type AgeCategory = 'puppy' | 'adult' | 'senior'

type DogSize =
  | 'extra_small'
  | 'small'
  | 'medium_1'
  | 'medium_2'
  | 'medium_3'
  | 'large_1'
  | 'large_2'
  | 'large_3'
  | 'large_4'
  | 'extra_large'

type EstimatedDailyPlanPrices = {
  ageCategory: AgeCategory
  size: DogSize
  GB: {
    mix: number
    all: number
  }
  NI: {
    mix: number
    all: number
  }
  IE: {
    mix: number
    all: number
  }
  NL: {
    mix: number
    all: number
  }
  BE: {
    mix: number
    all: number
  }
  PL: {
    mix: number
    all: number
  }
  CZ: {
    mix: number
    all: number
  }
  DE: {
    mix: number
    all: number
  }
  IT: {
    mix: number
    all: number
  }
}

const EstimatedDailyPlanPrices: Array<EstimatedDailyPlanPrices> = [
  {
    ageCategory: 'puppy',
    size: 'extra_small',
    GB: { mix: 137, all: 205 },
    NI: { mix: 137, all: 205 },
    IE: { mix: 147, all: 221 },
    NL: { mix: 155, all: 233 },
    BE: { mix: 155, all: 233 },
    IT: { mix: 155, all: 233 },
    PL: { mix: 544, all: 816 },
    CZ: { mix: 3235, all: 4852 },
    DE: { mix: 101, all: 151 }
  },
  {
    ageCategory: 'puppy',
    size: 'small',
    GB: { mix: 152, all: 228 },
    NI: { mix: 152, all: 228 },
    IE: { mix: 147, all: 221 },
    NL: { mix: 165, all: 248 },
    BE: { mix: 165, all: 248 },
    IT: { mix: 165, all: 248 },
    PL: { mix: 544, all: 816 },
    CZ: { mix: 3235, all: 4852 },
    DE: { mix: 145, all: 218 }
  },
  {
    ageCategory: 'puppy',
    size: 'medium_1',
    GB: { mix: 165, all: 247 },
    NI: { mix: 165, all: 247 },
    IE: { mix: 184, all: 276 },
    NL: { mix: 168, all: 252 },
    BE: { mix: 168, all: 252 },
    IT: { mix: 168, all: 252 },
    PL: { mix: 605, all: 908 },
    CZ: { mix: 3597, all: 5400 },
    DE: { mix: 175, all: 263 }
  },
  {
    ageCategory: 'puppy',
    size: 'medium_2',
    GB: { mix: 178, all: 267 },
    NI: { mix: 178, all: 267 },
    IE: { mix: 200, all: 300 },
    NL: { mix: 173, all: 259 },
    BE: { mix: 173, all: 259 },
    IT: { mix: 173, all: 259 },
    PL: { mix: 662, all: 993 },
    CZ: { mix: 3937, all: 5905 },
    DE: { mix: 176, all: 264 }
  },
  {
    ageCategory: 'puppy',
    size: 'medium_3',
    GB: { mix: 184, all: 276 },
    NI: { mix: 184, all: 276 },
    IE: { mix: 215, all: 323 },
    NL: { mix: 183, all: 275 },
    BE: { mix: 183, all: 275 },
    IT: { mix: 183, all: 275 },
    PL: { mix: 707, all: 1060 },
    CZ: { mix: 4204, all: 6304 },
    DE: { mix: 185, all: 278 }
  },
  {
    ageCategory: 'puppy',
    size: 'large_1',
    GB: { mix: 206, all: 309 },
    NI: { mix: 206, all: 309 },
    IE: { mix: 233, all: 350 },
    NL: { mix: 198, all: 297 },
    BE: { mix: 198, all: 297 },
    IT: { mix: 198, all: 297 },
    PL: { mix: 775, all: 1163 },
    CZ: { mix: 4609, all: 6916 },
    DE: { mix: 225, all: 338 }
  },
  {
    ageCategory: 'puppy',
    size: 'large_2',
    GB: { mix: 240, all: 360 },
    NI: { mix: 240, all: 360 },
    IE: { mix: 246, all: 369 },
    NL: { mix: 198, all: 297 },
    BE: { mix: 198, all: 297 },
    IT: { mix: 198, all: 297 },
    PL: { mix: 799, all: 1198 },
    CZ: { mix: 4752, all: 7124 },
    DE: { mix: 225, all: 338 }
  },
  {
    ageCategory: 'puppy',
    size: 'large_3',
    GB: { mix: 240, all: 360 },
    NI: { mix: 240, all: 360 },
    IE: { mix: 247, all: 371 },
    NL: { mix: 199, all: 299 },
    BE: { mix: 199, all: 299 },
    IT: { mix: 199, all: 299 },
    PL: { mix: 900, all: 1350 },
    CZ: { mix: 5352, all: 8028 },
    DE: { mix: 227, all: 341 }
  },
  {
    ageCategory: 'puppy',
    size: 'large_4',
    GB: { mix: 240, all: 360 },
    NI: { mix: 240, all: 360 },
    IE: { mix: 251, all: 376 },
    NL: { mix: 239, all: 359 },
    BE: { mix: 239, all: 359 },
    IT: { mix: 239, all: 359 },
    PL: { mix: 931, all: 1396 },
    CZ: { mix: 5537, all: 8302 },
    DE: { mix: 235, all: 352 }
  },
  {
    ageCategory: 'puppy',
    size: 'extra_large',
    GB: { mix: 286, all: 429 },
    NI: { mix: 286, all: 429 },
    IE: { mix: 251, all: 376 },
    NL: { mix: 273, all: 409 },
    BE: { mix: 273, all: 409 },
    IT: { mix: 273, all: 409 },
    PL: { mix: 931, all: 1396 },
    CZ: { mix: 5537, all: 8302 },
    DE: { mix: 267, all: 401 }
  },
  {
    ageCategory: 'senior',
    size: 'extra_small',
    GB: { mix: 143, all: 214 },
    NI: { mix: 143, all: 214 },
    IE: { mix: 168, all: 252 },
    NL: { mix: 166, all: 249 },
    BE: { mix: 166, all: 249 },
    IT: { mix: 166, all: 249 },
    PL: { mix: 498, all: 747 },
    CZ: { mix: 2962, all: 4442 },
    DE: { mix: 136, all: 204 }
  },
  {
    ageCategory: 'senior',
    size: 'small',
    GB: { mix: 143, all: 215 },
    NI: { mix: 143, all: 215 },
    IE: { mix: 178, all: 267 },
    NL: { mix: 167, all: 250 },
    BE: { mix: 167, all: 250 },
    IT: { mix: 167, all: 250 },
    PL: { mix: 528, all: 792 },
    CZ: { mix: 3140, all: 4710 },
    DE: { mix: 149, all: 223 }
  },
  {
    ageCategory: 'senior',
    size: 'medium_1',
    GB: { mix: 149, all: 223 },
    NI: { mix: 149, all: 223 },
    IE: { mix: 181, all: 271 },
    NL: { mix: 185, all: 278 },
    BE: { mix: 185, all: 278 },
    IT: { mix: 185, all: 278 },
    PL: { mix: 557, all: 836 },
    CZ: { mix: 3312, all: 4972 },
    DE: { mix: 157, all: 235 }
  },
  {
    ageCategory: 'senior',
    size: 'medium_2',
    GB: { mix: 150, all: 225 },
    NI: { mix: 150, all: 225 },
    IE: { mix: 183, all: 275 },
    NL: { mix: 191, all: 287 },
    BE: { mix: 191, all: 287 },
    IT: { mix: 191, all: 287 },
    PL: { mix: 601, all: 901 },
    CZ: { mix: 3574, all: 5358 },
    DE: { mix: 166, all: 249 }
  },
  {
    ageCategory: 'senior',
    size: 'medium_3',
    GB: { mix: 152, all: 228 },
    NI: { mix: 152, all: 228 },
    IE: { mix: 202, all: 303 },
    NL: { mix: 193, all: 290 },
    BE: { mix: 193, all: 290 },
    IT: { mix: 193, all: 290 },
    PL: { mix: 655, all: 982 },
    CZ: { mix: 3895, all: 5840 },
    DE: { mix: 173, all: 259 }
  },
  {
    ageCategory: 'senior',
    size: 'large_1',
    GB: { mix: 166, all: 249 },
    NI: { mix: 166, all: 249 },
    IE: { mix: 216, all: 324 },
    NL: { mix: 193, all: 290 },
    BE: { mix: 193, all: 290 },
    IT: { mix: 193, all: 290 },
    PL: { mix: 669, all: 1004 },
    CZ: { mix: 3979, all: 5971 },
    DE: { mix: 205, all: 307 }
  },
  {
    ageCategory: 'senior',
    size: 'large_2',
    GB: { mix: 181, all: 272 },
    NI: { mix: 181, all: 272 },
    IE: { mix: 235, all: 352 },
    NL: { mix: 199, all: 299 },
    BE: { mix: 199, all: 299 },
    IT: { mix: 199, all: 299 },
    PL: { mix: 801, all: 1201 },
    CZ: { mix: 4764, all: 7142 },
    DE: { mix: 207, all: 311 }
  },
  {
    ageCategory: 'senior',
    size: 'large_3',
    GB: { mix: 190, all: 285 },
    NI: { mix: 190, all: 285 },
    IE: { mix: 248, all: 372 },
    NL: { mix: 240, all: 360 },
    BE: { mix: 240, all: 360 },
    IT: { mix: 240, all: 360 },
    PL: { mix: 835, all: 1253 },
    CZ: { mix: 4866, all: 7452 },
    DE: { mix: 225, all: 338 }
  },
  {
    ageCategory: 'senior',
    size: 'large_4',
    GB: { mix: 203, all: 304 },
    NI: { mix: 203, all: 304 },
    IE: { mix: 252, all: 378 },
    NL: { mix: 243, all: 365 },
    BE: { mix: 243, all: 365 },
    IT: { mix: 243, all: 365 },
    PL: { mix: 845, all: 1267 },
    CZ: { mix: 5025, all: 7535 },
    DE: { mix: 266, all: 399 }
  },
  {
    ageCategory: 'senior',
    size: 'extra_large',
    GB: { mix: 205, all: 307 },
    NI: { mix: 205, all: 307 },
    IE: { mix: 253, all: 380 },
    NL: { mix: 253, all: 380 },
    BE: { mix: 253, all: 380 },
    IT: { mix: 253, all: 380 },
    PL: { mix: 880, all: 1320 },
    CZ: { mix: 5233, all: 7850 },
    DE: { mix: 287, all: 431 }
  },
  {
    ageCategory: 'adult',
    size: 'extra_small',
    GB: { mix: 143, all: 214 },
    NI: { mix: 143, all: 214 },
    IE: { mix: 168, all: 252 },
    NL: { mix: 166, all: 249 },
    BE: { mix: 166, all: 249 },
    IT: { mix: 166, all: 249 },
    PL: { mix: 498, all: 747 },
    CZ: { mix: 2962, all: 4442 },
    DE: { mix: 136, all: 204 }
  },
  {
    ageCategory: 'adult',
    size: 'small',
    GB: { mix: 143, all: 215 },
    NI: { mix: 143, all: 215 },
    IE: { mix: 178, all: 267 },
    NL: { mix: 167, all: 250 },
    BE: { mix: 167, all: 250 },
    IT: { mix: 167, all: 250 },
    PL: { mix: 528, all: 792 },
    CZ: { mix: 3140, all: 4710 },
    DE: { mix: 149, all: 223 }
  },
  {
    ageCategory: 'adult',
    size: 'medium_1',
    GB: { mix: 149, all: 223 },
    NI: { mix: 149, all: 223 },
    IE: { mix: 181, all: 271 },
    NL: { mix: 185, all: 278 },
    BE: { mix: 185, all: 278 },
    IT: { mix: 185, all: 278 },
    PL: { mix: 557, all: 836 },
    CZ: { mix: 3312, all: 4972 },
    DE: { mix: 157, all: 235 }
  },
  {
    ageCategory: 'adult',
    size: 'medium_2',
    GB: { mix: 150, all: 225 },
    NI: { mix: 150, all: 225 },
    IE: { mix: 183, all: 275 },
    NL: { mix: 191, all: 287 },
    BE: { mix: 191, all: 287 },
    IT: { mix: 191, all: 287 },
    PL: { mix: 601, all: 901 },
    CZ: { mix: 3574, all: 5358 },
    DE: { mix: 166, all: 249 }
  },
  {
    ageCategory: 'adult',
    size: 'medium_3',
    GB: { mix: 152, all: 228 },
    NI: { mix: 152, all: 228 },
    IE: { mix: 202, all: 303 },
    NL: { mix: 193, all: 290 },
    BE: { mix: 193, all: 290 },
    IT: { mix: 193, all: 290 },
    PL: { mix: 655, all: 982 },
    CZ: { mix: 3895, all: 5840 },
    DE: { mix: 173, all: 259 }
  },
  {
    ageCategory: 'adult',
    size: 'large_1',
    GB: { mix: 166, all: 249 },
    NI: { mix: 166, all: 249 },
    IE: { mix: 216, all: 324 },
    NL: { mix: 193, all: 290 },
    BE: { mix: 193, all: 290 },
    IT: { mix: 193, all: 290 },
    PL: { mix: 669, all: 1004 },
    CZ: { mix: 3979, all: 5971 },
    DE: { mix: 205, all: 307 }
  },
  {
    ageCategory: 'adult',
    size: 'large_2',
    GB: { mix: 181, all: 272 },
    NI: { mix: 181, all: 272 },
    IE: { mix: 235, all: 352 },
    NL: { mix: 199, all: 299 },
    BE: { mix: 199, all: 299 },
    IT: { mix: 199, all: 299 },
    PL: { mix: 801, all: 1201 },
    CZ: { mix: 4763, all: 7142 },
    DE: { mix: 207, all: 311 }
  },
  {
    ageCategory: 'adult',
    size: 'large_3',
    GB: { mix: 190, all: 285 },
    NI: { mix: 190, all: 285 },
    IE: { mix: 248, all: 372 },
    NL: { mix: 240, all: 360 },
    BE: { mix: 240, all: 360 },
    IT: { mix: 240, all: 360 },
    PL: { mix: 835, all: 1253 },
    CZ: { mix: 4966, all: 7452 },
    DE: { mix: 225, all: 338 }
  },
  {
    ageCategory: 'adult',
    size: 'large_4',
    GB: { mix: 203, all: 304 },
    NI: { mix: 203, all: 304 },
    IE: { mix: 252, all: 378 },
    NL: { mix: 243, all: 365 },
    BE: { mix: 243, all: 365 },
    IT: { mix: 243, all: 365 },
    PL: { mix: 845, all: 1267 },
    CZ: { mix: 5025, all: 7535 },
    DE: { mix: 266, all: 399 }
  },
  {
    ageCategory: 'adult',
    size: 'extra_large',
    GB: { mix: 205, all: 307 },
    NI: { mix: 205, all: 307 },
    IE: { mix: 253, all: 380 },
    NL: { mix: 253, all: 380 },
    BE: { mix: 253, all: 380 },
    IT: { mix: 253, all: 380 },
    PL: { mix: 880, all: 1320 },
    CZ: { mix: 5233, all: 7850 },
    DE: { mix: 287, all: 431 }
  }
]

export default EstimatedDailyPlanPrices
export type { AgeCategory, EstimatedDailyPlanPrices }
